import React, { Component, createContext } from 'react'
import ReactDOM from 'react-dom'
import { addPropsToAllChildren } from '../utilities'

const context = createContext({})

const { Provider, Consumer } = context

const ModalContent = ({ children, classNames }) => (
    <Consumer>
        {props =>
            props.open ? (
                <div className="modal">
                    <section className={`modal-main ${classNames || ''}`}>
                        {addPropsToAllChildren(children, props)}
                    </section>
                    <div
                        onClick={props.handleModal}
                        className="modal-overlay"
                    />
                </div>
            ) : null
        }
    </Consumer>
)

class Modal extends Component {
    state = { open: false }

    handleModal = () => {
        if (this.state.open && this.props.onClose) {
            this.props.onClose()
        }
        this.setState({ open: !this.state.open })
    }

    handleClose = event => {
        switch (event.keyCode) {
            case 27:
                this.setState({ open: false })
                if (this.props.onClose) {
                    this.props.onClose()
                }
                break
            default:
                break
        }
    }

    componentDidMount() {
        if (this.props.openByDefault) {
            this.setState({ open: true })
        }
        document.addEventListener('keydown', this.handleClose)
        document.addEventListener('showModal', this.handleModal)
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleClose)
        document.removeEventListener('showModal', this.handleClose)
    }

    render() {
        let TargetTag = this.props.targetTag || 'span'
        let targetClassName = this.props.targetClassName || ''

        return (
            <React.Fragment>
                <TargetTag
                    onClick={this.handleModal}
                    className={targetClassName}
                >
                    {this.props.callToAction}
                </TargetTag>
                <ModalPortal>
                    <Provider
                        value={{
                            handleModal: this.handleModal,
                            open: this.state.open,
                        }}
                    >
                        {this.props.children}
                    </Provider>
                </ModalPortal>
            </React.Fragment>
        )
    }
}

class ModalPortal extends React.Component {
    componentDidMount() {
        this.el = document.createElement('div')

        this.modalRoot = document.getElementById('modal-root')
        this.modalRoot.appendChild(this.el)
    }

    componentWillUnmount() {
        this.modalRoot.removeChild(this.el)
    }

    render() {
        return this.el
            ? ReactDOM.createPortal(this.props.children, this.el)
            : null
    }
}

export default Modal
export { ModalContent }
